export const MissingLocaleDates = {
  az: () => import('./az'),
  tat: () => import('./tat'),
  ps: () => import('./ps'),
  kg: () => import('./kg'),
  kk: () => import('./kk'),
  'fa-AF': () => import('./fa-AF'),
  so: () => import('./so'),
  pcm: () => import('./pcm'),
  ha: () => import('./ha'),
  bs: () => import('./bs'),
  uig: () => import('./uig'),
};
